/** Host role (formerly Anchor). Player role (formerly Personal). */
export function isHostGameMode(mode) {
  const m = String(mode || "").toLowerCase();
  return m === "host" || m === "anchor";
}

export function isPlayerGameMode(mode) {
  const m = String(mode || "").toLowerCase();
  return m === "player" || m === "personal";
}

export function isAnchorModeFromSettings(gs = {}) {
  if (gs.isAnchorMode === true) return true;
  return isHostGameMode(gs.mode);
}
